import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/inserting_gun_start_records',
  component: Management,
  redirect: '/inserting_gun_start_records/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/inserting_gun_start_records/List'),
      meta: {
        auth: Auth.listInsertingGunStartRecords
      }
    }
  ]
}
